export default __webpack_public_path__ + "static/media/extra_out_l7.f780840d.svg";